import React from 'react';
import Sidebar from '@/components/Sidebar';
import MobileNav from '@/components/MobileNav';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const Settings = ({ user }) => {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar user={user} />
      
      <div className="flex-1 flex flex-col overflow-hidden md:ml-64">
        <header className="bg-white border-b border-border px-6 py-4">
          <div>
            <h2 className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Manrope, sans-serif' }}>Settings</h2>
            <p className="text-sm text-muted-foreground">Manage integrations and preferences</p>
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-6 pb-24 md:pb-6">
          <div className="max-w-4xl mx-auto space-y-6">
              {/* User Profile */}
              <Card data-testid="user-profile-settings">
                <CardHeader>
                  <CardTitle>User Profile</CardTitle>
                  <CardDescription>Your account information</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <img
                      src={user?.picture || 'https://via.placeholder.com/80'}
                      alt={user?.name}
                      className="h-20 w-20 rounded-full"
                    />
                    <div>
                      <p className="font-semibold text-lg text-foreground">{user?.name}</p>
                      <p className="text-sm text-muted-foreground">{user?.email}</p>
                      <p className="text-sm text-muted-foreground mt-1">
                        Role: <span className="font-medium capitalize">{user?.role}</span>
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Download Reports */}
              <Card>
                <CardHeader>
                  <CardTitle>Export Data</CardTitle>
                  <CardDescription>Download your financial data</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div className="p-4 bg-accent/20 rounded-lg">
                      <div className="flex items-start justify-between">
                        <div>
                          <h4 className="font-semibold text-foreground mb-1">Monthly Reports</h4>
                          <p className="text-sm text-muted-foreground">
                            Download expenses, income, and summaries as CSV/Excel
                          </p>
                        </div>
                        <a href="/reports">
                          <Button>Go to Reports</Button>
                        </a>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
        </main>

        <MobileNav user={user} />
      </div>
    </div>
  );
};

export default Settings;
